import { render, staticRenderFns } from "./new-claim-modal.vue?vue&type=template&id=4802d3be&"
import script from "./new-claim-modal.vue?vue&type=script&lang=js&"
export * from "./new-claim-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports